<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="11">
        <v-form ref="queryForm">
          <v-row>
            <v-col cols="2" class="py-0">
              <z-source-selector label="去向"
                                 hide-details="auto"
                                 multiple
                                 v-model="queryRequest.outboundDirection"
                                 source="CompanyDicSelector"
                                 param="MATERIAL_DESTINATION"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <z-source-selector
                      clearable v-model="queryRequest.aimsWarehouseId"
                      prepend-inner-icon="search"
                      multiple
                      label="目标仓库"
                      single-line
                      hide-details="auto"
                      source="WarehouseSelector"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.reverseNo"
                            label="红冲单号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.relatedOrderNo"
                            label="红冲关联单号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <z-source-selector label="红冲类型"
                                 hide-details="auto"
                                 v-model="queryRequest.reverseType"
                                 source="DicSelector"
                                 param="REVERSE_TYPE"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <z-source-selector label="红冲状态"
                                 hide-details="auto"
                                 v-model="queryRequest.reverseState"
                                 source="DicSelector"
                                 param="REVERSE_STATE"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.applicant"
                            label="申请人"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.auditPerson"
                            label="审核人"/>
            </v-col>
            <v-col cols="3" class="py-0">
              <z-select-day
                      :hide-details="'auto'"
                      label="申请"
                      :startDateRules="[]"
                      :endDateRules="[]"
                      clearable
                      v-model="queryRequest.createDateTime"/>
            </v-col>
            <v-col cols="3" class="py-0">
              <z-select-day
                      :hide-details="'auto'"
                      label="审批"
                      :startDateRules="[]"
                      :endDateRules="[]"
                      clearable
                      v-model="queryRequest.auditDateTime"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.materielProdNo"
                            label="物料产品编号"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.materielName"
                            label="物料名称"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.materielBrand"
                            label="物料品牌"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.materielModel"
                            label="物料型号"/>
            </v-col>
            <v-col cols="2" class="py-0">
              <v-text-field prepend-inner-icon="search"
                            clearable
                            hide-details="auto"
                            @keydown.enter="queryPageReset"
                            v-model="queryRequest.factSerialNo"
                            label="出厂序列号"/>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-col cols="4" class="d-flex justify-end pb-0">
              <v-btn small color="primary"
                     @click="queryPageReset">
                搜索
                <v-icon right>mdi-magnify</v-icon>
              </v-btn>
              <v-btn color="primary" small class="ml-2" @click="addReverseDialog = true">
                新增红冲单
              </v-btn>
              <v-btn small color="primary"
                     class="ml-2"
                     @click="report">一键导出
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center">
      <v-col :sm="11" :xs="12" cols="8">
        <v-data-table
                :headers="headers"
                :items="list"
                disable-sort
                single-expand
                show-expand
                :options.sync="options"
                :page.sync="queryRequest.pagedQueryInfo.index"
                :server-items-length="total"
                :loading="loading"
                :footer-props="footerOptions"
                @item-expanded="onExpand"
                :search="search">

          <template v-slot:expanded-item="{ headers ,item}">
            <td :colspan="headers.length">
              <v-row class="d-flex mt-5" v-if="item.reverseType=='01' && reverseApplyInfoTableDetail.storageApplyInfoDetail !=null" >
                <v-col cols="1" class="pt-0 pr-0">
                  <span>红冲类型: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.reverseTypeDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>关联单号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.relatedOrderNo}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>申请人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.applicant}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>目标仓库: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.storageApplyInfoDetail.aimsWarehouseName}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>来源: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.storageApplyInfoDetail.resourcesDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>申请人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.storageApplyInfoDetail.applicant}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>申请日期: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.storageApplyInfoDetail.createDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>办理人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.storageApplyInfoDetail.auditPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>办理时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.storageApplyInfoDetail.auditDate}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>采购申请单: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.storageApplyInfoDetail.purchaseApplyNo}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>送货单号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.storageApplyInfoDetail.waybillNumber}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>备注: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.remark}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>拒绝原因: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.refuseReason}}</span>
                </v-col>
              </v-row>
              <v-row class="d-flex mt-5" v-else-if="item.reverseType=='02' && reverseApplyInfoTableDetail.outboundApplyInfoDetail !=null" >
                <v-col cols="1" class="pt-0 pr-0">
                  <span>红冲类型: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.reverseTypeDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>关联单号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.relatedOrderNo}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>申请人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.applicant}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>去向: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.outboundDirectionDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>领用人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.employer}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>领用日期: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.createDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>审核人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.auditPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>审核时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.auditDate}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>发货人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.outboundPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>发货时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.outboundDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>出库类型: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.outboundTypeDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>关联工单号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.outboundApplyInfoDetail.relatedOrderNo}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>备注: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.remark}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>拒绝原因: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{reverseApplyInfoTableDetail.refuseReason}}</span>
                </v-col>
              </v-row>
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn  small color="primary" width="83px"
                    v-show="item.reverseState == '01' && isAdmin=='admin'"

                   @click="auditDialogOpen(item.id)">
               审核
            </v-btn>
          </template>
          <template v-slot:item.materialsInfo="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{on,attrs}">
                                    <span @click="showMaterInfos(item)"
                                          class="d-inline-block text-truncate"
                                          style="cursor: pointer;color: blue;max-width: 150px;"
                                          v-bind="attrs"
                                          v-on="on">
                                         {{ item.materialsInfo }}
                                    </span>
              </template>
              <span>{{ item.materialsInfo }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="addReverseDialog" max-width="1200px">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">
            选择红冲类型和工单号
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">
            选择红冲物料
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3">
            填入红冲数量
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="mb-12" elevation="0">
              <v-card-text>
                <v-form ref = "addForm">
                  <v-row justify="center" class="d-flex justify-center">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span><span style="color: red;">*</span>红冲类型: </span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <z-source-selector source="DicSelector" label="请选择"
                                         param="REVERSE_TYPE"
                                         v-model="addRequest.reverseType"
                                         :rules="[v => !!v || '红冲类型']" required/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0">
                      <span><span style="color: red;">*</span>关联单号: </span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0" v-show="addRequest.reverseType == '01'">
                      <z-source-selector source="StorageApplyInfoSelector" label="请选择"
                                         @changevalue="relatedOrderNoChange"
                                         v-model="addRequest.relatedOrderId"
                                         :rules="[v => !!v || '请选择关联单号']" required/>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0" v-show="addRequest.reverseType == '02'">
                      <z-source-selector source="OutboundApplyInfoSelector" label="请选择"
                                         @changevalue="relatedOrderNoChange"
                                         v-model="addRequest.relatedOrderId"
                                         :rules="[v => !!v || '请选择关联单号']" required/>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0" v-show="addRequest.reverseType == null || addRequest.reverseType==''">
                      <z-source-selector source="StorageApplyInfoSelector" label="请选择"
                                         isDisabled
                                         v-model="addRequest.relatedOrderId"
                                         :loading="true"
                                         :rules="[v => !!v || '请选择关联单号']" required/>
                    </v-col>
                    <v-col cols="1" class="pt-6 pr-0">
                      <span><span style="color: red;">*</span>申请人员: </span>
                    </v-col>
                    <v-col cols="3" class="pt-0 pl-0">
                      <v-text-field label="申请人员" v-model="addRequest.applicant"
                                    :rules="[v => !!v || '请选择关联单号']" required/>
                    </v-col>
                  </v-row>

                  <v-row class="d-flex">
                    <v-col cols="1" class="pt-6 pr-0">
                      <span>备注: </span>
                    </v-col>
                    <v-col cols="5" class="pt-0 pl-0">
                      <v-text-field label="备注" v-model="addRequest.remark"/>
                    </v-col>
                  </v-row>


                  <v-row class="d-flex" v-if="addRequest.relatedOrderId !=''">
                    <v-col cols="4" class="pt-6 pr-0">
                      <b>管理单号信息 </b>
                    </v-col>
                  </v-row>
                  <v-row v-if="addRequest.reverseType=='02'  && addRequest.relatedOrderId !='' " class="d-flex">
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>去向: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.outboundDirectionDesc}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>领用人: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.employer}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>领用日期: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.createDateTime}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>审核人: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.auditPerson}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>审核时间: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.auditDate}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>发货人: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.outboundPerson}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>发货时间: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.outboundDateTime}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>出库类型: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.outboundTypeDesc}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>关联工单号: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{outboundApplyInfoDetail.relatedOrderNo}}</span>
                    </v-col>
                  </v-row>
                  <v-row v-else-if="addRequest.reverseType=='01' && addRequest.relatedOrderId !='' " class="d-flex">
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>目标仓库: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{storageApplyInfoDetail.aimsWarehouseName}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>来源: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{storageApplyInfoDetail.resourcesDesc}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>申请人: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{storageApplyInfoDetail.applicant}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>申请日期: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{storageApplyInfoDetail.createDateTime}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>办理人: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{storageApplyInfoDetail.auditPerson}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>办理时间: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{storageApplyInfoDetail.auditDate}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>采购申请单: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{storageApplyInfoDetail.purchaseApplyNo}}</span>
                    </v-col>
                    <v-col cols="1" class="pt-0 pr-0">
                      <span>送货单号: </span>
                    </v-col>
                    <v-col cols="2" class="pt-0 pl-0">
                      <span>{{storageApplyInfoDetail.waybillNumber}}</span>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
            <v-row justify="center">
              <v-btn color="primary" @click="nextStepFirst">
                下一步
              </v-btn>
            </v-row>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-card class="mb-12" color="lighten-1">

              <v-row class="d-flex">
                <v-col cols="4" class="pt-6 pr-0">
                  <b>管理单号信息 </b>
                </v-col>
              </v-row>
              <v-row v-if="addRequest.reverseType=='02'  && addRequest.relatedOrderId !=null " class="d-flex">
                <v-col cols="1" class="pt-0 pr-0">
                  <span>去向: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.outboundDirectionDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>领用人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.employer}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>领用日期: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.createDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>审核人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.auditPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>审核时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.auditDate}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>发货人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.outboundPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>发货时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.outboundDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>出库类型: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.outboundTypeDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>关联工单号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.relatedOrderNo}}</span>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                          style="width: 100%;"
                          v-model="materialSelected"
                          :headers="outboundMaterialHeaders"
                          :items="materialInfoList"
                          show-select
                          hide-default-footer
                          disable-pagination
                          item-key="materielId"
                  >
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row v-else-if="addRequest.reverseType=='01' && addRequest.relatedOrderId !=null " class="d-flex">
                <v-col cols="1" class="pt-0 pr-0">
                  <span>目标仓库: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.aimsWarehouseName}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>来源: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.resourcesDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>申请人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.applicant}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>申请日期: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.createDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>办理人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.auditPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>办理时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.auditDate}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>采购申请单: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.purchaseApplyNo}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>送货单号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.waybillNumber}}</span>
                </v-col>
                <v-col cols="12">
                  <v-data-table
                          style="width: 100%;"
                          v-model="materialSelected"
                          :headers="storageMaterialHeaders"
                          :items="materialInfoList"
                          show-select
                          hide-default-footer
                          disable-pagination
                          item-key="materielId"
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
            <v-row justify="center">
              <v-btn class="ml-5" text @click="e1 = 1">
                上一步
              </v-btn>
              <v-btn color="primary" @click="nextStepSecond">
                下一步
              </v-btn>
            </v-row>
          </v-stepper-content>`
          <v-stepper-content step="3">
            <v-card class="mb-12" color="lighten-1">
              <v-row class="d-flex">
                <v-col cols="4" class="pt-6 pr-0">
                  <b>管理单号信息 </b>
                </v-col>
              </v-row>
              <v-row v-if="addRequest.reverseType=='02'" class="d-flex">
                <v-col cols="1" class="pt-0 pr-0">
                  <span>去向: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.outboundDirectionDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>领用人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.employer}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>领用日期: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.createDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>审核人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.auditPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>审核时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.auditDate}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>发货人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.outboundPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>发货时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.outboundDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>出库类型: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.outboundTypeDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>关联工单号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{outboundApplyInfoDetail.relatedOrderNo}}</span>
                </v-col>
                <v-form ref="addFormOutbound" v-model="addFormOutboundValid">
                <v-col cols="12">
                  <v-data-table
                          disable-sort
                          style="width: 100%;"
                          :headers="outboundReverseMaterialHeaders"
                          :items="materialSelected"
                          hide-default-footer
                          disable-pagination
                          item-key="materielProdNo"
                  >
                    <template v-slot:item.reverseNum="{ item }">
                      <div >
                        <v-text-field id="reverseNum"
                                      prefix="-"
                                      :rules="[
                                                v => !!v && v>0|| '红冲数量必输'
                                                                ]"
                                      v-model="item.reverseNum"/>
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
                </v-form>
              </v-row>
              <v-row v-else-if="addRequest.reverseType=='01' && addRequest.relatedOrderId !=null " class="d-flex">
                <v-col cols="1" class="pt-0 pr-0">
                  <span>目标仓库: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.aimsWarehouseName}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>来源: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.resourcesDesc}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>申请人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.applicant}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>申请日期: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.createDateTime}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>办理人: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.auditPerson}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>办理时间: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.auditDate}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>采购申请单: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.purchaseApplyNo}}</span>
                </v-col>
                <v-col cols="1" class="pt-0 pr-0">
                  <span>送货单号: </span>
                </v-col>
                <v-col cols="2" class="pt-0 pl-0">
                  <span>{{storageApplyInfoDetail.waybillNumber}}</span>
                </v-col>
                <v-form ref="addFormStorage" v-model="addFormStorageValid">
                  <v-col cols="12">
                    <v-data-table
                            disable-sort
                            style="width: 100%;"
                            :headers="storageReverseMaterialHeaders"
                            :items="materialSelected"
                            hide-default-footer
                            disable-pagination
                            item-key="materielProdNo"
                    >
                      <template v-slot:item.reverseNum="{ item }">
                        <div >
                          <v-text-field id="reverseNum"
                                        prefix="-"
                                        :rules="[
                                                v => !!v && v>0|| '红冲数量必输'
                                                                ]"
                                        v-model="item.reverseNum"/>
                        </div>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-form>
              </v-row>
            </v-card>

            <v-row justify="center">
              <v-btn class="ml-5" text @click="e1 = 2">
                上一步
              </v-btn>
              <v-btn color="primary" :loading="addReverseLoading"  :disabled="!addFormStorageValid && !addFormOutboundValid" @click="reverseApplyRequest">
                提交
              </v-btn>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>

    <v-dialog v-model="auditDialog" max-width="1200px">
      <v-card  color="lighten-1">
        <v-card-title>
          <span class="headline">红冲审核</span>
        </v-card-title>
        <v-card-text>
            <v-row class="d-flex">
              <v-col cols="4" class="pt-6 pr-0">
                <b>基础信息 </b>
              </v-col>
            </v-row>
            <v-row class="d-flex" v-if="reverseApplyInfoDetail.reverseType=='01'" >
              <v-col cols="1" class="pt-0 pr-0">
                <span>红冲类型: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.reverseTypeDesc}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>关联单号: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.relatedOrderNo}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>申请人: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.applicant}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>目标仓库: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.storageApplyInfoDetail.aimsWarehouseName}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>来源: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.storageApplyInfoDetail.resourcesDesc}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>申请人: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.storageApplyInfoDetail.applicant}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>申请日期: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.storageApplyInfoDetail.createDateTime}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>办理人: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.storageApplyInfoDetail.auditPerson}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>办理时间: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.storageApplyInfoDetail.auditDate}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>采购申请单: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.storageApplyInfoDetail.purchaseApplyNo}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>送货单号: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.storageApplyInfoDetail.waybillNumber}}</span>
              </v-col>
            </v-row>
            <v-row class="d-flex" v-else >
              <v-col cols="1" class="pt-0 pr-0">
                <span>红冲类型: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.reverseTypeDesc}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>关联单号: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.relatedOrderNo}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>申请人: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.applicant}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
              <span>去向: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.outboundDirectionDesc}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>领用人: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.employer}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>领用日期: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.createDateTime}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>审核人: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.auditPerson}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>审核时间: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.auditDate}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>发货人: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.outboundPerson}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>发货时间: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.outboundDateTime}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>出库类型: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.outboundTypeDesc}}</span>
              </v-col>
              <v-col cols="1" class="pt-0 pr-0">
                <span>关联工单号: </span>
              </v-col>
              <v-col cols="2" class="pt-0 pl-0">
                <span>{{reverseApplyInfoDetail.outboundApplyInfoDetail.relatedOrderNo}}</span>
              </v-col>
          </v-row>
            <v-row v-if="reverseApplyInfoDetail.reverseType=='01'">
              <v-col cols="12">
                <v-data-table
                        disable-sort
                        :headers="storageReverseMaterialHeaders"
                        :items="reverseApplyInfoDetail.reverseMaterialInfoList"
                        hide-default-footer
                >
                  <template v-slot:item.reverseNum="{ item }">
                    <div >
                      <span>-{{item.reverseNum}}</span>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row v-else>
            <v-col cols="12">
              <v-data-table
                      disable-sort
                      :headers="outboundReverseMaterialHeaders"
                      :items="reverseApplyInfoDetail.reverseMaterialInfoList"
                      hide-default-footer
              >
                <template v-slot:item.reverseNum="{ item }">
                  <div >
                    <span>-{{item.reverseNum}}</span>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" width="100px" @click="reverseRefuseDialog = true" dark>
            拒绝
          </v-btn>
          <v-btn :loading="reverseHandleLoading" color="blue darken-1" width="100px" @click="reverseHandle"
                 dark>
            同意
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="reverseRefuseDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">拒绝原因</span>
        </v-card-title>
        <v-textarea
                counter="100"
                :rules="[v => v.length <= 100 || '最多不能超过100字']"
                v-model="refuseReason"
                color="teal"
                class="ma-5"
                outlined
                hide-detail="true"
                label="
              请输入拒绝原因"
        >
        </v-textarea>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" width="100px" @click="reverseRefuseDialog = false" dark>取消</v-btn>
          <v-btn color="primary" width="100px" @click="reverseRefuse" :loading="reverseRefuseLoading" dark>
            确认
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <z-notify ref="notify"></z-notify>

    <v-dialog v-model="showMaterFlag" max-width="1200px">
      <v-card>
        <v-card-title>
          <span class="headline">物料详细信息</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pa-0">
            <v-form ref="auditForm">
              <v-row>
                <v-data-table
                        style="width: 100%;"
                        :headers="reverseMaterialShowHeaders"
                        :items="tableMaterInfos"
                        :server-items-length="tableMaterInfos.length"
                        hide-default-footer
                        disable-sort>
                  <template v-slot:item.specification="{ item }">
                    {{
                    (item.specification ? item.specification : '') + (item.specification2 ? '-' + item.specification2 : '')
                    + (item.specification3 ? '-' + item.specification3 : '') + (item.specification4 ? '-' + item.specification4 : '')
                    }}
                  </template>
                  <template v-slot:item.withdrawalFlag="{ item }">
                    {{ item.withdrawalFlag ? '需退库' : '不需要退库' }}
                  </template>
                </v-data-table>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" width="100px" @click="showMaterFlag = false" dark>关闭</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="exportLoading"
              fullscreen
              overlay-color="white">
      <div
              style="width: 100%;height: 100%;background-color: rgba(255,255,255,0.5);display: flex;align-items: center;justify-content: center">
        <div style="text-align: center">
          <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
          >
          </v-progress-circular>
          <br/>
          <p style="margin-top: 10px; color: blue">报表生成中,请稍等...</p>
        </div>
      </div>
    </v-dialog>
  </v-container>

</template>

<script>
  import {pagedQuery,relatedOrderNoDetail,apply,detail,audit,reportExport} from '@/api/ReverseManagement';
  import {queryDetails} from '@/api/WarehouseManagement';
  import {details} from '@/api/storageApplyInfo';
  import {dataChangedCountMixin,dataCatchMixin} from "@/mixin"
  import {mapGetters} from "vuex";

  export default {
    name:"ReverseManagement",
    computed: {
      ...mapGetters([
        "isAdmin"
      ]),
    },
    mixins: [dataChangedCountMixin,dataCatchMixin],
    data(){
      return {
        showMaterFlag:false,
        addFormStorageValid:false,
        addFormOutboundValid:false,
        queryRequest: {
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          },
          reverseNo: "",
          relatedOrderNo: "",
          reverseType: "",
          reverseState: "",
          applicant: "",
          auditPerson: "",
          createDateTime:[],
          auditDateTime:[],
          materielProdNo:"",
          materielName:"",
          materielBrand:"",
          materielModel:"",
          factSerialNo:""
        },
        headers: [
          {text: '红冲单号', value: 'reverseNo', align: 'center'},
          {text: '红冲关联单号', value: 'relatedOrderNo', align: 'center'},
          {text: '红冲类型', value: 'reverseTypeDesc', align: 'center'},
          {text: '仓库', value: 'aimsWarehouseName', align: 'center'},
          {text: '去向', value: 'outboundDirectionDesc', align: 'center'},
          {text: '申请人', value: 'applicant', align: 'center'},
          {text: '申请时间', value: 'createDateTime', align: 'center'},
          {text: '审核人', value: 'auditPerson', align: 'center'},
          {text: '审批时间', value: 'auditDateTime', align: 'center'},
          {text: '红冲状态', value: 'reverseStateDesc', align: 'center'},
          {text: '物料信息', value: 'materialsInfo', align: 'center'},
          {text: '操作', value: 'actions', align: 'center',width:200 },
          {text: '', value: 'data-table-expand', align: 'center'},
        ],
        storageMaterialHeaders:[
          {text: '产品编号', value: 'materielProdNo', align: 'center'},
          {text: '物料唯一编码', value: 'materielId', align: 'center'},
          {text: '物料名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格', value: 'specification', align: 'center'},
          {text: '品类', value: 'category', align: 'center'},
          {text: '子类', value: 'subType', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
          {text: '状态', value: 'stateDesc', align: 'center' },
          {text: '申请入库数量', value: 'applyNum', align: 'center'},
          {text: '库存数量', value: 'quantity', align: 'center'},
          {text: '单位', value: 'unitDesc', align: 'center'},
          {text: '标识', value: 'businessLabelDesc', align: 'center'},
        ],
        outboundMaterialHeaders:[
          {text: '产品编号', value: 'materielProdNo', align: 'center'},
          {text: '仓库名称', value: 'warehouseName', align: 'center'},
          {text: '物料唯一编码', value: 'materielId', align: 'center'},
          {text: '物料名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格', value: 'specification', align: 'center'},
          {text: '品类', value: 'category', align: 'center'},
          {text: '子类', value: 'subType', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
          {text: '状态', value: 'stateDesc', align: 'center' },
          {text: '申请出库数量', value: 'applyNum', align: 'center'},
          {text: '单位', value: 'unitDesc', align: 'center'},
          {text: '标识', value: 'businessLabelDesc', align: 'center'},
        ],
        storageReverseMaterialHeaders:[
          {text: '产品编号', value: 'materielProdNo', align: 'center'},
          {text: '物料唯一编码', value: 'materielId', align: 'center'},
          {text: '物料名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格', value: 'specification', align: 'center'},
          {text: '品类', value: 'category', align: 'center'},
          {text: '子类', value: 'subType', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
          {text: '状态', value: 'stateDesc', align: 'center' },
          {text: '申请入库数量', value: 'applyNum', align: 'center'},
          {text: '库存数量', value: 'quantity', align: 'center'},
          {text: '已红冲数量', value: 'reversedNum', align: 'center'},
          {text: '红冲数量', value: 'reverseNum', align: 'center',width:100},
          {text: '单位', value: 'unitDesc', align: 'center'},
          {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
        ],
        outboundReverseMaterialHeaders:[
          {text: '产品编号', value: 'materielProdNo', align: 'center'},
          {text: '仓库名称', value: 'warehouseName', align: 'center'},
          {text: '物料唯一编码', value: 'materielId', align: 'center'},
          {text: '物料名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格', value: 'specification', align: 'center'},
          {text: '品类', value: 'category', align: 'center'},
          {text: '子类', value: 'subType', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
          {text: '状态', value: 'stateDesc', align: 'center' },
          {text: '申请出库数量', value: 'applyNum', align: 'center'},
          {text: '已红冲数量', value: 'reversedNum', align: 'center'},
          {text: '红冲数量', value: 'reverseNum', align: 'center',width:100},
          {text: '单位', value: 'unitDesc', align: 'center'},
          {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
        ],
        outboundReverseMaterialShowHeaders:[
          {text: '产品编号', value: 'materielProdNo', align: 'center'},
          {text: '仓库名称', value: 'warehouseName', align: 'center'},
          {text: '物料唯一编码', value: 'materielId', align: 'center'},
          {text: '物料名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格', value: 'specification', align: 'center'},
          {text: '品类', value: 'category', align: 'center'},
          {text: '子类', value: 'subType', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
          {text: '状态', value: 'stateDesc', align: 'center' },
          {text: '申请出库数量', value: 'applyNum', align: 'center'},
          {text: '红冲数量', value: 'reverseNum', align: 'center',width:100},
          {text: '单位', value: 'unit', align: 'center'},
          {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
        ],
        storageReverseMaterialShowHeaders:[
          {text: '产品编号', value: 'materielProdNo', align: 'center'},
          {text: '物料唯一编码', value: 'materielId', align: 'center'},
          {text: '物料名称', value: 'materielName', align: 'center'},
          {text: '品牌', value: 'materielBrand', align: 'center'},
          {text: '型号', value: 'materielModel', align: 'center'},
          {text: '规格', value: 'specification', align: 'center'},
          {text: '品类', value: 'category', align: 'center'},
          {text: '子类', value: 'subType', align: 'center'},
          {text: '出厂序列号', value: 'factSerialNo', align: 'center'},
          {text: '状态', value: 'stateDesc', align: 'center' },
          {text: '申请入库数量', value: 'applyNum', align: 'center'},
          {text: '红冲数量', value: 'reverseNum', align: 'center',width:100},
          {text: '单位', value: 'unit', align: 'center'},
          {text: '业务标签', value: 'businessLabelDesc', align: 'center'},
        ],
        reverseMaterialShowHeaders :[],
        list:[],
        total:0,
        search:'',
        loading: false,
        options: {},
        footerOptions: {
          itemsPerPageOptions: [10, 50, 100, 200]
        },
        addReverseDialog: false,
        addReverseLoading: false,
        auditDialog: false,
        reverseRefuseDialog: false,
        e1: 1 ,
        addRequest: {
          relatedOrderId:"",
          reverseType:"",
          applicant:"",
          remark:"",
          reverseMaterialInfoList:[],
        },
        reverseApplyInfoDetail:{
          storageApplyInfoDetail:{},
          outboundApplyInfoDetail:{},
          reverseMaterialInfoList:[]
        },
        reverseApplyInfoTableDetail:{
          storageApplyInfoDetail:{},
          outboundApplyInfoDetail:{},
          reverseMaterialInfoList:[]
        },
        refuseReason:"",
        reverseRefuseLoading: false,
        reverseHandleLoading: false,
        materialInfoList:[],
        materialSelected:[],
        storageApplyInfoDetail:{
          aimsWarehouseName:"",
          resourcesDesc:"",
          applicant:"",
          createDateTime:"",
          auditPerson:"",
          auditDate:"",
          purchaseApplyNo:"",
          waybillNumber:""
        },
        outboundApplyInfoDetail:{
          outboundDirection:"",
          outboundDirectionDesc:"",
          employer:"",
          outboundDate:"",
          auditPerson:"",
          auditDate:"",
          outboundPerson:"",
          outboundDateTime:"",
          outboundTypeDesc:"",
          relatedOrderNo:""
        },
        tableMaterInfos : [],
        exportLoading : false
      }
    },
    methods:{
      //物料信息
      showMaterInfos(item) {
        if(item.reverseType == '01'){
          this.reverseMaterialShowHeaders = this.storageReverseMaterialShowHeaders;
        }else{
          this.reverseMaterialShowHeaders = this.outboundReverseMaterialShowHeaders;
        }
        this.tableMaterInfos = item.materialInfoList;
        this.showMaterFlag = true;
      },
      nextStepFirst(){
        if(this.$refs.addForm.validate()){
          this.e1 = 2;
        }
      },
      nextStepSecond(){
        if(this.materialSelected.length > 0){
          this.e1 = 3;
        }else{
          this.$refs.notify.show("请选择具体红冲物料", {timeout: 1000, color: 'red'});
        }
      },
      //分页查询
      queryPageReset() {
        this.queryRequest.pagedQueryInfo.index = 1;
        this.queryPageQuery();
      },
      queryPageQuery() {
        this.loading = true;
        pagedQuery(this.queryRequest).then(res => {
          this.list = res.list;
          this.total = res.total;
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      relatedOrderNoChange(){
        this.materialSelected = [];
        if(this.addRequest.reverseType == "01"){
          let storageApplyDetailRequest = {
            id : this.addRequest.relatedOrderId
          };
          details(storageApplyDetailRequest).then(res => {
            console.log(res)
            this.storageApplyInfoDetail = res;
          }).catch(() => {
          })
          let relatedOrderNoDetailRequest = {
            relatedOrderId : this.addRequest.relatedOrderId,
            reverseType : this.addRequest.reverseType
          };
          relatedOrderNoDetail(relatedOrderNoDetailRequest).then(res => {
            console.log(res)
            this.materialInfoList = res;
          }).catch(() => {
          })
        }else{
          let storageApplyDetailRequest = {
            id : this.addRequest.relatedOrderId
          };
          queryDetails(storageApplyDetailRequest).then(res => {
            console.log(res)
            this.outboundApplyInfoDetail = res;
          }).catch(() => {
          })
          let relatedOrderNoDetailRequest = {
            relatedOrderId : this.addRequest.relatedOrderId,
            reverseType : this.addRequest.reverseType
          };
          relatedOrderNoDetail(relatedOrderNoDetailRequest).then(res => {
            console.log(res)
            this.materialInfoList = res;
          }).catch(() => {
          })
        }
      },
      reverseApplyRequest(){
        this.addReverseLoading = true;
        this.addRequest.reverseMaterialInfoList = this.materialSelected;
        apply(this.addRequest).then(() =>{
          this.addReverseDialog = false;
          this.addReverseLoading = false;
          this.$refs.notify.show("申请成功", {timeout: 1000, color: 'success'});
          this.e1 = 1;
          Object.assign(this.$data.addRequest, this.$options.data().addRequest);
          this.materialSelected = [];
          this.queryPageReset();
          this.queryPageQuery();
          this.$refs.addForm.resetValidation()
        }).catch(() =>{
          this.addReverseLoading = false;
        })
      },
      auditDialogOpen(id){
        detail(id).then(res =>{
          this.auditDialog = true;
          this.reverseApplyInfoDetail = res
        })
      },
      onExpand({item,value}){
        if(value){
          detail(item.id).then(res =>{
            this.reverseApplyInfoTableDetail = res
          })
        }
      },
      reverseHandle() {
        this.reverseHandleLoading = true;
        let auditRequest = {
          id: this.reverseApplyInfoDetail.id,
          auditType: true,
        };
        audit(auditRequest).then(() => {
          this.auditDialog = false;
          this.reverseHandleLoading = false;
          this.$refs.notify.show("请求成功", {timeout: 1000, color: 'success'});
          this.queryPageReset();
          this.queryPageQuery();
        }).catch(()=>{
          this.reverseHandleLoading = false;
        })
      },
      reverseRefuse(){
        this.reverseRefuseLoading = true;
        let auditRequest = {
          id: this.reverseApplyInfoDetail.id,
          auditType: false,
          refuseReason: this.refuseReason
        };
        audit(auditRequest).then(() => {
          this.auditDialog = false;
          this.reverseRefuseDialog = false;
          this.reverseRefuseLoading = false;
          this.$refs.notify.show("请求成功", {timeout: 1000, color: 'success'});
          this.queryPageReset();
          this.queryPageQuery();
        }).catch(() =>{
          this.reverseRefuseLoading = false;
        })
      },
      report() {
        this.exportLoading = true;
        reportExport(this.queryRequest).then(res => {
          this.$router.push({
            path: '/export-report-queue?id=' + res
          });
          this.exportLoading = false;
        }).catch(() => {
          this.exportLoading = false;
        });
      },
    },
    created() {
      this.queryPageReset();
      this.queryPageQuery();
    },
    watch:{
      options: {
        handler(val) {
          if (val.itemsPerPage == -1) {
            this.queryRequest.pagedQueryInfo.index = 1
            this.queryRequest.pagedQueryInfo.pageSize = 999999
          } else {
            this.queryRequest.pagedQueryInfo.index = val.page
            this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
          }
          this.queryPageQuery()
        },
      },
    }
  }
</script>
